import { useAuth } from '@/auth/AuthContext'
import { requireAuth } from '@/auth/requireAuth'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { getColumns } from '@/components/users/users-columns'
import { UsersDataTable } from '@/components/users/users-data-table'
import { PageTitle } from '@/layout/page-title'
import { getPeople } from '@/people'
import { createFileRoute, Link, useLoaderData } from '@tanstack/react-router'
import { AlertCircleIcon } from 'lucide-react'

export const Route = createFileRoute('/(app)/_layout/users/')({
  component: RouteComponent,
  loader: async () => {
    const {data, error} = await getPeople();
    return { people: data, error };
  },
  beforeLoad: requireAuth
})

function RouteComponent() {
  const auth = useAuth();
  const email = auth?.user?.profile.preferred_username || auth?.user?.profile.upn as string;
  const columns = getColumns(email);
  const { people, error } = useLoaderData({ from: '/(app)/_layout/users/' });
  return (
    <div className="container max-w-[1900px] mx-auto py-10 px-4">
      <div className="space-y-4">
        <PageTitle title="Users" 
        
        rightActions={
          <Button asChild>
            <Link to="/users/create" className="text-sm">
              Create New User
            </Link>
          </Button>
        }
        />
        {error &&<Alert variant="destructive">
        <AlertCircleIcon />
        <AlertTitle>Error loading users</AlertTitle>
        <AlertDescription>
          {error.message || "An unexpected error occurred while loading users."}
          <br />
          Please try again later or contact support if the issue persists.
          <br />
          <Button variant="outline" className="mt-2" onClick={() => window.location.reload()}>
            Retry
          </Button>
        </AlertDescription>
      </Alert>}
        <UsersDataTable columns={columns} data={people ?? []} />
      </div>
    </div>
  )
}
